export const formatPhoneNumber = (value) => {
  if (typeof value !== 'undefined' && value !== null) {
    if (value != '0') {
      let numbers = value.toString().replace(/\D/g, '');
      let char = { 0: '(', 3: ') ', 6: ' - ' };
      value = '';
      for (var i = 0; i < numbers.length; i++) {
        value += (char[i] || '') + numbers[i];
      }
    } else {
      value = '';
    }
  }
  if (value && value.length > 16) {
    value = value.substring(0, 16);
  }

  return value;
};
